import script from "./SkillsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillsSection.vue?vue&type=script&setup=true&lang=ts"

import "./SkillsSection.vue?vue&type=style&index=0&id=d2d56866&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2d56866"]])

export default __exports__